planner-index
  .row
    .col-lg-4.col-md-6
      orders-planner-date-ui(tag-scope="orders_planner_date_ui")
    .col-lg-8.col-md-6.text-right
      orders-planner-show-all-phases(if="{isSpecificPhases()}" tag-scope="")
      orders-planner-search-tags(tag-scope="forms_planner_search")
  forms-planner-search(tag-scope="forms_planner_search")
  orders-planner-warnings(tag-scope="planner_index")
  .orders-wrap(each="{orders, i in this.splitedOrders()}")
    orders-planner-orders(data-edit="{opts.dataEdit}" orders="{orders}" index="{i}")
  orders-planner-task-editor(if="{opts.dataEdit}" tag-scope="orders_planner_task_editor" multiple="{true}")
  orders-planner-dialog-tooltip-schedule(tag-scope="orders_planner_dialog_tooltip_schedule")
  orders-planner-dialog-tooltip-orders-phase(tag-scope="orders_planner_dialog_tooltip_orders_phase")
  orders-planner-dialog-save-tasks-memo(if="{opts.dataEdit}" tag-scope="orders_planner_dialog_save_tasks_memo")
  orders-planner-dialog-create-schedule(if="{opts.dataEdit}" tag-scope="orders_planner_dialog_create_schedule")
  orders-planner-dialog-line-menu(if="{opts.dataEdit}" tag-scope="orders_planner_dialog_line_menu")
  orders-planner-dialog-update-under(if="{opts.dataEdit}" tag-scope="orders_planner_dialog_update_under")
  orders-planner-dialog-update-status(if="{opts.dataEdit}" tag-scope="orders_planner_dialog_update_status")
  forms-schedules-update(if="{opts.dataEdit}" tag-scope="forms_schedules_update")
  forms-schedules-destroy(if="{opts.dataEdit}" tag-scope="forms_schedules_destroy")
  orders-planner-scroll(tag-scope="{orders_planner}")
  script(type="typescript").
    this.mixin('orders.planner.multiple');
  style(scope).
    .order-wrap {
      background: #FFF;
    }
    .order-wrap orders-planner-props .phases .label{
      filter: opacity(50%);
    }
    .order-wrap:hover orders-planner-props .phases .label{
      filter: opacity(100%);
    }
